<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='跟进记录'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='500'
      >
        <template v-slot:content>
           <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-select
                    :items="contactsPersonItems"
                    label="联系人姓名"
                    v-model="form.contactsId"
                    hide-details='auto'
                    filled rounded  dense
                    item-text='name'
                    item-value="id"
                    :rules="required"
                  >
                  <template v-slot:item="{ item }">
                    ({{item.type === 1 ? '客户方' : '渠道方'}}){{item.name}}
                  </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-select
                    :items="customerFollowTypeItems"
                    label="跟进方式"
                    v-model="form.followTypeId"
                    hide-details='auto'
                    filled rounded  dense
                    item-text='name'
                    item-value="id"
                    :rules="required"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row v-if="form.followTypeId !== $constants.CustomerFollowType.OUT_ID">
                <v-col cols="12">
                    <base-material-date
                      ref='date'
                      :rules="required"
                       hide-details='auto'
                       filled rounded  dense
                       label='拜访时间'
                       v-model='form.followTimeStr'
                     >
                     </base-material-date>
                </v-col>
              </v-row>
              <v-row v-if="form.followTypeId === $constants.CustomerFollowType.OUT_ID">
                <v-col cols="12">
                  <base-material-time-range-picker :filed-props='{ filled: true, rounded: true, singleLine: true, hideDetails: true, rules: [ value => !!value || "此项为必填项!"] }' v-model="form.times" ></base-material-time-range-picker>
                </v-col>
                <v-col cols="12">
                  <base-marerial-user-select label='协同人' :dense="false" hide-details filled rounded single-line v-model="form.assistIdList"></base-marerial-user-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                 <v-textarea
                   :rules="required"
                   filled rounded  dense
                   v-model="form.content"
                   label="跟进内容"></v-textarea>
                </v-col>
              </v-row>

            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" rounded :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { save } from '@/api/customer/follow.js'

  export default {
    name: 'CustomerFollowEdit',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          customer: null,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]+.?[0-99]*$/.test(value) || '必须输入数字',
        ],
        contactsPersonItems: [],
        customerFollowTypeItems: [],
        form: {
          id: '',
          customerId: '',
          contactsId: '',
          followTypeId: '',
          followTimeStr: '',
          followTime: '',
          content: '',
          assistIdList: [],
          assistIds: '',
          times: []
        },
        defForm: {
          id: '',
          customerId: '',
          contactsId: '',
          followTypeId: '',
          followTimeStr: '',
          followTime: '',
          content: '',
          assistIdList: '',
          assistIds: '',
          times: []
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.form.followTime = new Date(this.form.followTimeStr).getTime() / 1000
          this.form.assistIds = JSON.stringify(this.form.assistIdList).replace('[', '').replace(']', '')
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.customerFollowTypePid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.customerFollowTypePid === result.id) {
                this_.customerFollowTypeItems = result.data
             }
           })
          }
        })
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
            this.contactsPersonItems = this.item.data.allContactsPersons
          } else {
            this.form.customerId = this.item.customer.id
            this.contactsPersonItems = this.item.customer.allContactsPersons
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      },
    },
    created () {
      this.getTypes()
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
